<template>
    <div class="layout">
        <Tabs type="card" @on-click="tabClick">
            <!-- 待处理 -->
            <TabPane :label="this.$t('reworkProcess.t1')" name="1">
                <m-assembly-table
                    :total="total"
                    :loading="loading"
                    :formData="formData"
                    :columns="columns"
                    :data="data"
                    :settings="settings"
                    :tableButtons="tableButtons"
                    @onSubmit="onSubmit"
                    @onPageSizeChange="onPageSizeChange"
                    @onCurrentPageChange="onCurrentPageChange"
                    ref="rwTableRef1" thDrag
                >
                </m-assembly-table>
            </TabPane>
            <!-- 已处理 -->
            <TabPane :label="this.$t('reworkProcess.t2')" name="2">
                <m-assembly-table
                    :total="total2"
                    :loading="loading2"
                    :formData="formData2"
                    :columns="columns2"
                    :settings="settings2"
                    :data="data2"
                    @onSubmit="onSubmit2"
                    @onPageSizeChange="onPageSizeChange2"
                    @onCurrentPageChange="onCurrentPageChange2"
                    ref="rwTableRef2" thDrag
                >
                </m-assembly-table>
            </TabPane>
        </Tabs>
    </div>
</template>

<script>
import axios from 'axios';
import mAssemblyTable from '@/components/awesome/page/assembly_table/index.js';
export default {
    name: 'reworkProcess',
    components: {
        mAssemblyTable
    },
    data() {
        return {
            dict: {
                flowStatusList: [
                    {label: this.$t('reworkProcess.t3'), value: 'Pending'}, // 待发起
                    {label: this.$t('reworkProcess.t4'), value: 'ProgrammeInput'}, // 方案填写
                    {label: this.$t('reworkProcess.t5'), value: 'ProgrammePproval'}, // 方案审批
                    {label: this.$t('reworkProcess.t6'), value: 'Discard'}, // 废弃
                ]
            },
            chooseTab: '1',
            page: 1,
            page2: 1,
            pageSize: 10,
            pageSize2: 10,
            total: 0,
            total2: 0,
            loading: false,
            loading2: false,
            formData: {
                row: 1,
                items: []
            },
            formData2: {
                row: 1,
                items: []
            },
            cacheSelection: [],
            tableButtons: {
                systemButtons: [],
                customButtons: []
            },
            columns: {
                columns: [
                    {
                        title: this.$t('reworkProcess.t7'), // 流程编码
                        key: 'FLOWNO',
                        ellipsis: true,
                        align: 'center',
                        render: (h, params) => {
                            return h('span', {
                                style: {
                                    color: '#3aa2eb',
                                    cursor: 'pointer'
                                },
                                on: {
                                    click: () => {
                                        this.$router.push({
                                            name: 'reworkProcessDetail',
                                            query: {
                                                FLOWNO: params.row.FLOWNO, // 流程编号
                                                FLOWID: params.row.FLOWID, // 流程id
                                                currStatus: 'N' // 'N'表示待处理
                                            }
                                        });
                                    }
                                }
                            }, params.row.FLOWNO);
                        }
                    },
                    {
                        title: this.$t('reworkProcess.t8'), // 故障原因
                        key: 'REWORK_CAUSE',
                        align: 'center',
                        render: (h, params) => {
                            return h('Tooltip', {
                                    props: {
                                        content: params.row.REWORK_CAUSE,
                                        placement: 'bottom'
                                    },
                                    class: 'm-tooltip-overflow'
                            }, params.row.REWORK_CAUSE);
                        }
                    },
                    {
                        title: this.$t('reworkProcess.t9'), // 当前步骤
                        key: 'FLOW_STATUS',
                        align: 'center',
                        render: (h, params) => {
                             let flowStatusName = (this.dict.flowStatusList.find(item => item.value === params.row.FLOW_STATUS) || {}).label || '';
                             return h('span', {}, flowStatusName);
                        }
                    },
                    // {
                    //     title: '计划返工日期',
                    //     key: 'PLAN_REWORK_DATE',
                    //     align: 'center',
                    //     width: 130
                    // },
                    {
                        title: this.$t('reworkProcess.t10'), // 当前处理人
                        key: 'SUPPLIER_CODE',
                        align: 'center',
                    },
                    {
                        title: this.$t('reworkProcess.t11'), // 发起人
                        key: 'USER_CREATED',
                        align: 'center',
                    },
                    {
                        title: this.$t('reworkProcess.t12'), // 发起时间
                        key: 'DATETIME_CREATED',
                        align: 'center',
                    }
                ]
            },
            cacheSelection2: [],
            columns2: {
                columns: [
                    {
                        title: this.$t('reworkProcess.t7'), // 流程编码
                        key: 'FLOWNO',
                        ellipsis: true,
                        align: 'center',
                        render: (h, params) => {
                            return h('a', {
                                // style: {
                                //     color: '#3aa2eb',
                                //     cursor: 'pointer'
                                // },
                                on: {
                                    click: () => {
                                        this.$router.push({
                                            name: 'reworkProcessDetail',
                                            query: {
                                                FLOWNO: params.row.FLOWNO, // 流程编号
                                                FLOWID: params.row.FLOWID, // 流程id
                                                currStatus: 'Y' // 'Y'表示已处理
                                            }
                                        });
                                    }
                                }
                            }, params.row.FLOWNO);
                        }
                    },
                    {
                        title: this.$t('reworkProcess.t8'), // 故障原因
                        key: 'REWORK_CAUSE',
                        render: (h, params) => {
                            return h('Tooltip', {
                                    props: {
                                        content: params.row.REWORK_CAUSE,
                                        placement: 'bottom'
                                    },
                                    class: 'm-tooltip-overflow'
                            }, params.row.REWORK_CAUSE);
                        }
                    },
                    {
                        title: this.$t('reworkProcess.t9'), // 当前步骤
                        key: 'FLOW_STATUS',
                        align: 'center',
                        render: (h, params) => {
                             let flowStatusName = (this.dict.flowStatusList.find(item => item.value === params.row.FLOW_STATUS) || {}).label || '';
                             return h('span', {}, flowStatusName);
                        }
                    },
                    {
                        title: this.$t('reworkProcess.t13'), // 计划返工日期
                        key: 'PLAN_REWORK_DATE',
                        align: 'center',
                    },
                    {
                        title: this.$t('reworkProcess.t10'), // 当前处理人
                        key: 'SUPPLIER_CODE',
                        align: 'center',
                    },
                    {
                        title: this.$t('reworkProcess.t11'), // 发起人
                        key: 'USER_CREATED',
                        align: 'center',
                    },
                    {
                        title: this.$t('reworkProcess.t12'), // 发起时间
                        key: 'DATETIME_CREATED',
                        align: 'center',
                    }
                ]
            },
            data: [],
            data2: [],
            mdmCode: '',
            settings: {
                needPager: true,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [10, 30, 50, 100],
                needSearch: false,
                needValidation: false,
                needClear: false,
                needSetTable: false
            },
            settings2: {
                needPager: true,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [10, 30, 50, 100],
                needSearch: false,
                needValidation: false
            }
        };
    },
    methods: {
        tabClick (name) {
            console.log('name::', name);
            this.chooseTab = name;
            if (name === '1') {
                this.page = 1;
                this.onSubmit();
            } else {
                this.page2 = 1;
                this.onSubmit2();
            }
        },
        search (formName) {
            let params = {};
            if (formName === 'rwTableRef1') {
                this.loading = true;
                params.status = '0'; // 0表示待处理
            } else {
                this.loading2 = true;
                params.status = '1'; // 1表示非待处理
            }
            params.supplier_code = this.mdmCode;
            params.pageSize = formName === 'rwTableRef1' ? this.pageSize : this.pageSize2;
            params.pageIndex = formName === 'rwTableRef1' ? this.page : this.page2;
            params.language = this.$i18n.locale;
            console.log('params', params);
            axios.post('/qms2gsc/oemRework/getListForeign', params)
            .then((res) => {
                let rep = res.data;
                if (formName === 'rwTableRef1') {
                    this.loading = false;
                } else {
                    this.loading2 = false;
                }
                if (rep.result) {
                    if (formName === 'rwTableRef1') {
                        this.data = rep.data;
                        this.total = parseInt(rep.total);
                    } else {
                        this.data2 = rep.data;
                        this.total2 = parseInt(rep.total);
                    }
                } else {
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: this.$t('common.error1')
                    });
                }
            }).catch(() => {
                if (formName === 'rwTableRef1') {
                    this.loading = false;
                } else {
                    this.loading2 = false;
                }
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('common.error1')
                });
            });
        },
        onSubmit () {
            this.search('rwTableRef1');
        },
        onPageSizeChange (page, pageSize) {
            this.page = 1;
            this.pageSize = pageSize;
            this.onSubmit();
        },
        onCurrentPageChange (page) {
            this.page = page;
            this.onSubmit();
        },
        onSubmit2 () {
            this.search('rwTableRef2');
        },
        onPageSizeChange2 (page, pageSize) {
            this.page2 = 1;
            this.pageSize2 = pageSize;
            this.onSubmit2();
        },
        onCurrentPageChange2 (page) {
            this.page2 = page;
            this.onSubmit2();
        },
    },
    mounted() {
        this.mdmCode = JSON.parse(localStorage.getItem('supplierInfo')).mdmCode;
        if (this.chooseTab === '1') {
            this.onSubmit();
        } else {
            this.onSubmit2();
        }
    }
};
</script>

<style lang="less" scoped>
.layout {
    background: #fff;
    padding: 10px;
    /deep/ .m-card-body {
        padding: 0px;
    }
}
</style>
